import { defineComponent } from 'vue';
import { apps } from 'ionicons/icons';
import { IonItem, IonIcon, IonLabel } from '@ionic/vue';
export default defineComponent({
    name: "AppsButton",
    setup() {
        return { apps };
    },
    components: {
        IonItem,
        IonIcon,
        IonLabel
    }
});
